import { initCacheInvalidatorRegister } from '../cacheRegisterConstructor';

export enum SiteDocumentsCacheEvents {
  CREATE = 'CREATE',
  UPDATE = 'UPDATE',
  DELETE = 'DELETE',
  MOVE = 'MOVE',
}

type CacheParams = {
  organizationId: string;
  projectId: string;
  folderId?: string;
};

const cacheRegister = initCacheInvalidatorRegister<
  typeof SiteDocumentsCacheEvents,
  CacheParams
>(SiteDocumentsCacheEvents);

export const invalidateSiteDocumentsCache = cacheRegister.invalidate;
export const siteDocumentsCacheRegister = cacheRegister.register;
